import { render, staticRenderFns } from "./StepUpFailure.vue?vue&type=template&id=17b95fb4&scoped=true&"
import script from "./StepUpFailure.vue?vue&type=script&lang=js&"
export * from "./StepUpFailure.vue?vue&type=script&lang=js&"
import style0 from "./StepUpFailure.vue?vue&type=style&index=0&id=17b95fb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b95fb4",
  null
  
)

export default component.exports